import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE, PRICE_BEFORE } from '../data/baseball';
const recap = ['6 volumes', '5 bonuses', '240 pages', 'Ages 5 to 14+'];
const reassurances = ['Instant digital download', 'Print-ready PDF', '7-day money-back guarantee'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-109" data-mp="15c2era85gpsf">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-110" data-mp="1jbahue7foi1w" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-111" data-mp="1t2yd6q742j8n">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-112" data-mp="1t2ewtdx402wq">
          Your baseball season can be <em className="text-red-700" data-id="element-113" data-mp="223mhuuam778v">fully planned – starting today.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-114" data-mp="221a0ai8rqywc">
          Instead of searching for drills, drawing every station yourself and spending Sunday nights
          planning, you have one organized package for the whole season. More time for what really
          matters:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-115" data-mp="x41yk8hzrjcy">
          Your players. The game. Your life off the field.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-116" data-mp="120scap6bq2v7">
          {recap.map(item => <li key={item} data-id="element-117" data-mp="1b39xd0a8spgm">{item}</li>)}
        </ul>

        <p className="mt-8 text-lg text-slate-900/60" data-id="element-118" data-mp="1b1qjfgc26qi0">Before <s data-id="element-119" data-mp="1ftqeovh6ov89">{PRICE_BEFORE}</s></p>
        <p className="mt-2 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-120" data-mp="1fvkyu7kmsjba">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-121" data-mp="1ksl5okpb1q3g">One-time payment – no subscription.</p>

        <div className="mt-8 flex justify-center" data-id="element-122" data-mp="1pu0tgkivaapj">
          <CtaButton className="w-full sm:w-auto" data-id="element-123" data-mp="1ttjctbv1idq9" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-124" data-mp="1tryjtqodj2ui">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-125" data-mp="3lvubnktrir12">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-126" data-mp="3lthpevgz1ui7" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}